/*
 * Copyright (c) 2025, Gather
 * https://gather.life
 */

'use client';

import Grid from '@mui/material/Grid2';
import type { ReactNode } from 'react';

import { Icon, Typography } from '@marketplace/gather-ui/components';
import { PageContentsSectionMainPanel } from '@marketplace/gather-ui/layouts';
import { GatherLightSystemTokens } from '@marketplace/gather-ui/theme';

type SearchLoadingProps = {
  SearchComponent: ReactNode;
};

export default function CatalogVehiclesErrorView({
  SearchComponent,
}: SearchLoadingProps): ReactNode {
  return (
    <PageContentsSectionMainPanel>
      <Grid
        container
        alignItems='center'
        component='section'
        direction='column'
        height='100%'
        justifyContent='center'
        rowSpacing='40px'
      >
        <Grid container alignItems='center' direction='column' rowSpacing={4}>
          <Grid>
            <Icon
              useStroke
              height='auto'
              icon='errorOutlined'
              sx={{ color: GatherLightSystemTokens.OnSurface.primary }}
              width={180}
            />
          </Grid>
          <Grid textAlign='center'>
            <Typography size='small' variant='display'>
              Sorry we had an issue fetching the results
            </Typography>
          </Grid>
          <Grid textAlign='center'>
            <Typography variant='body'>
              Try hitting the refreshing the page or starting your search over again here
            </Typography>
          </Grid>
        </Grid>
        <Grid width='100%'>{SearchComponent}</Grid>
      </Grid>
    </PageContentsSectionMainPanel>
  );
}
